// import React from 'react'

// const AdvertisementLocationReports = () => {
//   return (
//     <div>AdvertisementLocationReports</div>
//   )
// }

// export default AdvertisementLocationReports

import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Divider,
  Paper,
  Grid,
  SwipeableDrawer,
  Typography,
  TextField,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import ToastApp from "../../../ToastApp";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import PrintIcon from "@mui/icons-material/Print";
import dayjs from "dayjs";

function Row({ row, index }: { row: any; index: number }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <React.Fragment>
      <TableRow
        // onClick={() => setIsOpen(!isOpen)}
        sx={{ border: "1px gray solid" }}
      >
        {/* <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell> */}

        <TableCell style={{ border: "1px gray solid" }} align="center">
          {index + 1}
        </TableCell>
        <TableCell
          // onClick={() => setIsOpen(!isOpen)}
          // onMouseEnter={() => setIsHovered(true)}
          // onMouseLeave={() => setIsHovered(false)}
          style={{
            border: "1px gray solid",
            // cursor: "pointer",
            // textDecoration: isHovered ? "underline" : "none",
            // color: isHovered ? "blue" : "inherit",
          }}
        >
          {row.zoneName}
        </TableCell>
        <TableCell style={{ border: "1px gray solid", wordWrap: "break-word" }}>
          {row.wardName}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }}>
          {row.categoryName}
        </TableCell>
        <TableCell
          style={{
            border: "1px gray solid",
            borderCollapse: "collapse",
            padding: "5px",
          }}
          align="center"
        >
          {row.subCategoryName}
          {/* {dayjs(row.contractFromDate).format("DD-MM-YYYY")} */}
        </TableCell>
        <TableCell
          style={{
            border: "1px gray solid",
            borderCollapse: "collapse",
            padding: "5px",
          }}
          align="center"
        >
          {row.areaName}
          {/* {dayjs(row.contractToDate).format("DD-MM-YYYY")} */}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.nearestLocation}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.noOfSites}
        </TableCell>
        <TableCell style={{ border: "1px gray solid" }} align="center">
          {row.latitute}
        </TableCell>

        <TableCell
          style={{ border: "1px gray solid", wordWrap: "break-word" }}
          align="center"
        >
          {row.longitude}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, margin: "5px" }}
          colSpan={10}
        >
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <Box sx={{ marginTop: 1, marginBottom: 1 }}>
              <Table
                aria-label="purchases"
                style={{
                  border: "1px gray solid",
                  borderCollapse: "collapse",
                  width: "100%",
                  borderRadius: "15px",
                }}
              >
                <TableHead
                  style={{
                    border: "1px gray solid",
                    borderCollapse: "collapse",
                    // borderRadius:"15px"
                  }}
                >
                  <TableRow sx={{ backgroundColor: "lightblue" }}>
                    <TableCell
                      colSpan={10}
                      height={30}
                      sx={{
                        // backgroundColor: "lightskyblue",
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                        fontSize: 17,
                        fontWeight: 600,
                        // borderRadius:"15px"
                      }}
                    >
                      Advertisement Details
                    </TableCell>
                  </TableRow>
                  <TableRow
                  //  sx={{ backgroundColor: "orange" }}
                  >
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Sr. No.
                    </TableCell>
                    {/* <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Case No
                    </TableCell> */}
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Advt. Sub Type Name
                    </TableCell>
                    {/* <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Settled
                    </TableCell> */}
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Category Name
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Length
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Width
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Area sq. mtr.
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Rate
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  style={{
                    border: "1px gray solid",
                    borderCollapse: "collapse",
                    margin: "5px",
                  }}
                >
                  {row?.advertisementEntryTran?.map((tran: any, index: any) => (
                    <TableRow
                      key={index}
                      style={{
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                    >
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                      >
                        {tran.advertisementSubTypeName}
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.categoryName}
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.length}
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.width}
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.squarMtr}
                      </TableCell>
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.rate}
                      </TableCell>
                      {/*  <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {dayjs(tran.fill_date).format("DD-MM-YYYY")}

                      </TableCell>*/}
                      {/* <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {dayjs(tran.update_status_date).format("DD-MM-YYYY")}

                      </TableCell> */}
                      <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.amount}
                      </TableCell>
                      {/* <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.fill_date}
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
            <Box sx={{ marginTop: 1, marginBottom: 1 }}>
              <Table
                aria-label="purchases"
                style={{
                  border: "1px gray solid",
                  borderCollapse: "collapse",
                  width: "100%",
                  borderRadius: "15px",
                }}
              >
                <TableHead
                  style={{
                    border: "1px gray solid",
                    borderCollapse: "collapse",
                    // borderRadius:"15px"
                  }}
                >
                  <TableRow sx={{ backgroundColor: "lightblue" }}>
                    <TableCell
                      colSpan={11}
                      height={30}
                      sx={{
                        // backgroundColor: "lightskyblue",
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                        fontSize: 17,
                        fontWeight: 600,
                        // borderRadius:"15px"
                      }}
                    >
                      Advertisement Payment Details
                    </TableCell>
                  </TableRow>
                  <TableRow
                  //  sx={{ backgroundColor: "orange" }}
                  >
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Sr. No.
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Payment Mode
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Payment Date
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Amount
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        border: "1px gray solid",
                        borderCollapse: "collapse",
                        padding: "5px",
                      }}
                      align="center"
                    >
                      Trasanction ID
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  style={{
                    border: "1px gray solid",
                    borderCollapse: "collapse",
                    margin: "5px",
                  }}
                >
                  {row?.advertisementEntryPayTran?.map(
                    (tran: any, index: any) => (
                      <TableRow
                        key={index}
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                      >
                        <TableCell
                          style={{
                            border: "1px gray solid",
                            borderCollapse: "collapse",
                            padding: "5px",
                          }}
                          align="center"
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          style={{
                            border: "1px gray solid",
                            borderCollapse: "collapse",
                            padding: "5px",
                          }}
                          align="center"
                        >
                          {tran.paymentModeName}
                        </TableCell>
                        {/* <TableCell>{tran.subCategoryName}</TableCell>
                      <TableCell>{tran.advertisementTypeName}</TableCell> */}
                        {/* <TableCell
                        style={{
                          border: "1px gray solid",
                          borderCollapse: "collapse",
                          padding: "5px",
                        }}
                        align="center"
                      >
                        {tran.settled}
                      </TableCell> */}
                        <TableCell
                          style={{
                            border: "1px gray solid",
                            borderCollapse: "collapse",
                            padding: "5px",
                          }}
                          align="center"
                        >
                          {dayjs(tran.paymentDate).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell
                          style={{
                            border: "1px gray solid",
                            borderCollapse: "collapse",
                            padding: "5px",
                          }}
                          align="center"
                        >
                          {tran.paidAmount}
                        </TableCell>
                        <TableCell
                          style={{
                            border: "1px gray solid",
                            borderCollapse: "collapse",
                            padding: "5px",
                          }}
                          align="center"
                        >
                          {tran.recTrasactionID}
                          {/* {dayjs(tran.remDate).format("DD-MM-YYYY")} */}
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function AdvertisementLocationReports() {
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [optionCategory, setOptionCategory] = useState([
    { value: "-1", label: "Select Category Name" },
  ]);
  const [optionWard, setOptionWard] = useState([
    { value: "-1", label: "Select Ward NAme" },
  ]);
  const [optionZone, setOptionZone] = useState([
    { value: "-1", label: "Select Zone Name" },
  ]);
  const [optionSubCategory, setOptionSubCategory] = useState([
    { value: "-1", label: "Select Sub Category Name" },
  ]);

  const { t } = useTranslation();

  const tstatus = [
    // { value: null, label: "Select Status" },
    { value: true, label: "Active" },
    { value: false, label: "InActive" },
  ];

  useEffect(() => {
    getZoneData();
    getWardData();
    getCategoryData();
    getSubCategoryData();
  }, []);

  const getZoneData = () => {
    const collectData = {
      "zoneID": -1,
      "user_ID": 0,
      "isActive": true
    };

    axios
      .post(
        HOST_URL.HOST_URL + "Zone/GetZonemaster",
        collectData
      )
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["zoneName"],
            value: res.data.data[index]["zoneID"],
          });
        }
        setOptionZone(arr);
      });
  };

  const getWardData = () => {
    const collectData = {
      "wardID": -1,
      "zoneID":-1,
  "user_ID": 0,
  "isActive": true
    };

    axios
      .post(HOST_URL.HOST_URL + "Ward/GetWardmaster", collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["wardName"],
            value: res.data.data[index]["wardID"],
          });
        }
        setOptionWard(arr);
      });
  };

  const getCategoryData = () => {
    const collectData = {
      "categoryID": -1,
  "user_ID": 0,
  "isActive": true
    };

    axios
      .post(
        HOST_URL.HOST_URL + "Category/GetCategorymaster",
        collectData
      )
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["categoryName"],
            value: res.data.data[index]["categoryID"],
          });
        }
        setOptionCategory(arr);
      });
  };
  
  const getSubCategoryData = () => {
    const collectData = {
      "subCategoryID": -1,
  "categoryID": 0,
  "user_ID": 0,
  "isActive": true
    };

    axios
      .post(
        HOST_URL.HOST_URL + "SubCategory/GetSubCategorymaster",
        collectData
      )
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["subCategoryName"],
            value: res.data.data[index]["subCategoryID"],
          });
        }
        setOptionSubCategory(arr);
      });
  };
  const handleFilterButtonClick = () => {
    setFilterDrawerOpen(true);
    console.log("value handleFilterButtonClick", filterDrawerOpen);
  };

  const handleCloseDrawer = () => {
    setFilterDrawerOpen(false);
  };

  interface FormValues {
    adLocationID: number;
    zoneID: number;
    wardID: number;
    categoryID: number;
    subCategoryID: number;
    user_ID: number;
    isActive: boolean | null;
  }

  const initialValues: FormValues = {
    adLocationID: 0,
    zoneID: 0,
    wardID: 0,
    categoryID: 0,
    subCategoryID: 0,
    user_ID: 0,
    isActive: null,
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      if (
        !values.adLocationID ||
        !values.zoneID ||
        !values.wardID ||
        !values.categoryID || !values.subCategoryID || !values.user_ID  || !values.isActive
      ) {
        values.adLocationID = -1;
        values.zoneID = -1;
        values.wardID = -1;
        values.categoryID = -1;
        values.subCategoryID = -1;
        values.user_ID = -1;
        values.isActive = true;
      }
    
      const response = await axios.post(
        HOST_URL.HOST_URL + `AdvertiseLocation/GetAdvertiseLocation`,
        values
      );
      setData(response.data.data);
      handleCloseDrawer();

      if (response.data.isSuccess) {
        toast.success(response.data.mesg);
      } else {
        toast.error(response.data.mesg);
      }
    },
  });

  const handlePrint = () => {
    const contentElement = document.getElementById("tabcont");
    if (contentElement) {
      const clonedContent = contentElement.cloneNode(true) as HTMLElement;

      // const collapsedRows = clonedContent.querySelectorAll(
      //   ".MuiCollapse-container"
      // );
      // collapsedRows.forEach((row:any) => {(row as HTMLElement).style.display = "block";
      // });

      const filterButton = clonedContent.querySelector(".filter-button");
      if (filterButton) {
        filterButton.remove();
      }
      const printButton = clonedContent.querySelector(".print-button");
      if (printButton) {
        printButton.remove();
      }

      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.body.appendChild(clonedContent);

        printWindow.print();
      } else {
        console.error("Error: Unable to open print window.");
      }
    }
  };

  const fieldConfigurations = [
    {
      name: "zoneID",
      label: "Select Zone Name",
      isAutocomplete: true,
      options: optionZone.map((option: any) => ({
        value: option.value,
        label: option.label,
      })),
    },
    {
      name: "wardID",
      label: "Select Ward Name",
      isAutocomplete: true,
      options: optionWard.map((option: any) => ({
        value: option.value,
        label: option.label,
      })),
    },
    {
      name: "categoryID",
      label: "Select Category Name",
      isAutocomplete: true,
      options: optionCategory.map((option: any) => ({
        value: option.value,
        label: option.label,
      })),
    },
    {
      name: "subCategoryID",
      label: "Select Sub Category Name",
      isAutocomplete: true,
      options: optionSubCategory.map((option: any) => ({
        value: option.value,
        label: option.label,
      })),
    },
    {
          name: "isActive",
          label: "Select Status",
          isAutocomplete: true,
          // options: tstatus
          options: tstatus.map((option:any) => ({
            value: option.value,
            label: option.label,
          })),
        },
  ];

  return (
    <Card
      style={{
        width: "100%",
        backgroundColor: "#E9FDEE",
        border: ".5px solid #FF7722 ",
        marginTop: "3vh",
      }}
    >
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          "& .MuiDataGrid-colCell": {
            backgroundColor: "#f0ad4e",
            color: "#000",
            fontSize: 17,
            fontWeight: 900,
          },
        }}
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            Advertisement Location Report
          </Typography>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 20,
            }}
          >
            <Button
              type="button"
              onClick={() => handleFilterButtonClick()}
              style={{
                backgroundColor: "blue",
                fontSize: "15px",
                color: "#fff",
                textTransform: "none",
                cursor: "pointer",
              }}
            >
              <FilterAltIcon />
              Filter
            </Button>
            <Button
              type="button"
              onClick={handlePrint}
              style={{
                backgroundColor: "blue",
                fontSize: "15px",
                color: "#fff",
                textTransform: "none",
                cursor: "pointer",
              }}
            >
              <PrintIcon />
              Print
            </Button>
            <iframe
              id="ifmcontentstoprint"
              style={{ height: "0px", width: "0px", position: "absolute" }}
            ></iframe>
          </div>
          <SwipeableDrawer
            anchor="right"
            open={filterDrawerOpen}
            onClose={handleCloseDrawer}
            onOpen={() => {}}
            slotProps={{
              backdrop: {
                style: { backgroundColor: "rgba(0, 0, 0, 0.7)" },
              },
            }}
            PaperProps={{
              style: {
                width: 310,
                boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.2)",
                // backgroundColor: "whitesmoke",
              },
            }}
            style={{
              zIndex: 1300,
              // width:"280px"
            }}
          >
            {/* Drawer content */}
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{
                margin: "20px 0px",
                // backgroundColor: "#1976d2",
                // color: "#fff",
                // borderBottomLeftRadius: "15px",
                // borderBottomRightRadius: "15px",
              }}
              align="center"
            >
              Advt. Location Report
            </Typography>
            <Divider />

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} sx={{ margin: 0 }}>
                  {fieldConfigurations.map((field) => (
                    <Grid xs={11} item key={field.name}>
                      {field.isAutocomplete ? (
                        <div>
                          <Grid sx={{ marginBottom: "6px" }}>
                            <Autocomplete
                              disablePortal
                              fullWidth
                              size="small"
                              options={field.options}
                              onChange={(event, newValue) => {
                                console.log("check value", newValue);
                                formik.setFieldValue(
                                  field.name,
                                  newValue?.value
                                );
                                formik.setFieldTouched(field.name, true);
                                formik.setFieldTouched(field.name, false);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label={field.label} />
                              )}
                            />
                          </Grid>
                        </div>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  ))}
                  <Grid
                    xs={11}
                    item
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                  >
                    <Button type="submit" variant="contained">
                      Search
                    </Button>
                    <Button
                      type="reset"
                      variant="contained"
                      onClick={() => formik.resetForm()}
                    >
                      Clear
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>
          </SwipeableDrawer>
        </div>

        <Divider />
        <br />
        <TableContainer
          component={Paper}
          id="tabcont"
          sx={{ maxHeight: "65vh" }}
        >
          <Table
            aria-label="collapsible table"
            style={{
              border: "1px gray solid",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "lightblue",
                fontSize: 20,
                color: "white",
                fontWeight: 600,
                border: "1px gray solid",
                borderCollapse: "collapse",
              }}
            >
              <TableRow>
                <TableCell
                  colSpan={10}
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                  }}
                >
                  Advertisement Location Report
                </TableCell>
              </TableRow>
              <TableRow
                style={{
                  border: "1px gray solid",
                  borderCollapse: "collapse",
                  position: "sticky",
                }}
              >
                {/* <TableCell /> */}
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "5vh",
                  }}
                  align="center"
                >
                  Sr. No.
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "15vh",
                  }}
                >
                  Zone 
                </TableCell>
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "24vh",
                  }}
                  align="center"
                >
                  Ward 
                </TableCell>
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "15vh",
                  }}
                  align="center"
                >
                 Category 
                </TableCell>
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "25vh",
                  }}
                  align="left"
                >
                  Sub Category 
                </TableCell>
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "15vh",
                  }}
                  align="center"
                >
                 Area 
                </TableCell>
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "15vh",
                  }}
                  align="center"
                >
                  Landmark
                </TableCell>
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "15vh",
                  }}
                  align="center"
                >
                  No. of Sites
                </TableCell>
                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "10vh",
                  }}
                  align="center"
                >
                  Lat
                </TableCell>

                <TableCell
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    border: "1px gray solid",
                    padding: "5px",
                    width: "10vh",
                  }}
                  align="center"
                >
                  Long
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any, index: any) => (
                <Row key={row.adLocationID} row={row} index={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Card>
  );
}
